import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { supportPlans } from "@/lib/data";
import { Check, ArrowUpRight } from "lucide-react";

export default function SupportPlans() {
    return (
        <section data-testid="support-plans" className="border-t border-line">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-20 md:py-32">
                <div className="mb-14 grid md:grid-cols-2 gap-8">
                    <div>
                        <p className="eyebrow mb-6">Recurring support</p>
                        <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[0.95]">Support that continues after opening day.</h2>
                    </div>
                    <p className="text-muted max-w-md self-end leading-relaxed">
                        Three plan structures — pick a starting point, then we tune the specifics to your locations, systems and hours. Custom pricing is confirmed after a short assessment.
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {supportPlans.map((plan, i) => (
                        <motion.div
                            key={plan.name}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            className={`relative p-8 md:p-10 border ${plan.featured ? "bg-panel text-bg border-panel" : "border-line bg-bg hover:bg-bg-alt"} transition-colors duration-300`}
                        >
                            {plan.featured && (
                                <span className="absolute -top-3 left-6 bg-gold text-ink text-[10px] tracking-widest font-mono px-2 py-1 uppercase">Most requested</span>
                            )}
                            <p className={`eyebrow mb-6 ${plan.featured ? "text-bg/50" : ""}`}>{`Plan ${String(i + 1).padStart(2, "0")}`}</p>
                            <h3 className={`font-display text-3xl md:text-4xl tracking-tight mb-2 ${plan.featured ? "text-bg" : "text-ink"}`}>{plan.name}</h3>
                            <p className={`text-sm mb-8 ${plan.featured ? "text-bg/70" : "text-muted"}`}>{plan.tagline}</p>
                            <ul className="space-y-3 mb-10">
                                {plan.features.map((f) => (
                                    <li key={f} className={`flex items-start gap-3 text-sm ${plan.featured ? "text-bg/85" : "text-ink-2"}`}>
                                        <Check className={`w-4 h-4 mt-0.5 flex-none ${plan.featured ? "text-gold" : "text-gold"}`} />
                                        <span>{f}</span>
                                    </li>
                                ))}
                            </ul>
                            <Link to="/contact" className={`inline-flex items-center gap-2 text-sm ${plan.featured ? "text-bg link-underline" : "text-ink link-underline"}`}>
                                Request a Support Plan Assessment <ArrowUpRight className="w-4 h-4" />
                            </Link>
                        </motion.div>
                    ))}
                </div>
                <p className="mt-10 text-xs font-mono tracking-widest uppercase text-muted">Custom pricing based on location count, system complexity and service requirements.</p>
            </div>
        </section>
    );
}
